import { render, staticRenderFns } from "./AvatarImg.vue?vue&type=template&id=259ec5a0"
import script from "./AvatarImg.vue?vue&type=script&lang=js"
export * from "./AvatarImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports